<template>
  <div>
    <v-dialog v-model="dialog" max-width="560px" :persistent="loading">
      <v-card>
        <v-card-title class="headline">
          Gestión de Lista Negra
          <v-spacer />
          <v-btn icon @click="closeModal" :disabled="loading">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <p class="mb-4">
            ¿Desea agregar a <strong>{{ userName }}</strong> a la Lista Negra?
          </p>

          <div class="d-flex align-center mb-4">
            <span :class="['mr-2', !blacklistEnabled ? 'grey--text text--darken-1 font-weight-bold' : 'grey--text']">NO</span>
            <v-switch
              v-model="blacklistEnabled"
              inset
              color="red darken-1"
              hide-details
              class="ma-0 pa-0"
            />
            <span :class="['ml-2', blacklistEnabled ? 'red--text text--darken-1 font-weight-bold' : 'grey--text']">SÍ</span>
          </div>

          <v-textarea
            v-if="blacklistEnabled"
            v-model="reason"
            label="Motivo"
            outlined
            rows="4"
            auto-grow
            counter="500"
            maxlength="500"
            no-resize
          />
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text @click="closeModal" :disabled="loading">
            Cancelar
          </v-btn>
          <v-btn
            v-if="can('users:blacklist')"
            color="primary"
            dark
            :loading="loading"
            @click="saveBlacklist"
          >
            {{ isAlreadyBlacklisted ? 'Actualizar Registro' : 'Guardar Registro' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api360Service from '../services/360.service.js';
import { can } from '../utils/permissions';

export default {
  name: 'BlacklistModal',
  props: {
    value: { type: Boolean, default: false },
    userInfo: { type: Object, default: () => ({}) },
    token: { type: String, default: null },
    currentBlacklist: { type: Object, default: null }
  },
  data() {
    return {
      blacklistEnabled: false,
      reason: '',
      loading: false
    };
  },
  computed: {
    dialog: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    },
    userName() {
      return this.userInfo?.name || 'usuario';
    },
    userRut() {
      return this.userInfo?.rut || '';
    },
    isAlreadyBlacklisted() {
      return Boolean(this.currentBlacklist);
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        if (this.currentBlacklist) {
          this.blacklistEnabled = true;
          this.reason = this.currentBlacklist.reason || '';
        } else {
          this.blacklistEnabled = false;
          this.reason = '';
        }
      }
    }
  },
  methods: {
    can,
    closeModal() {
      this.dialog = false;
      this.blacklistEnabled = false;
      this.reason = '';
    },
    async saveBlacklist() {
      // CASO 1: Ya está en lista negra y switch en NO → desactivar
      if (this.isAlreadyBlacklisted && !this.blacklistEnabled) {
        this.loading = true;
        try {
          await Api360Service.updateBlacklist(this.userRut, null, false, this.token);
          this.$emit('saved');
          this.closeModal();
        } catch (error) {
          this.$emit('error', 'No se pudo desactivar el registro de Lista Negra.');
        } finally {
          this.loading = false;
        }
        return;
      }

      // CASO 2: Switch en NO y nunca estuvo en lista negra → solo cerrar
      if (!this.blacklistEnabled) {
        this.closeModal();
        return;
      }

      // CASOS 3 y 4: Switch en SÍ → validar motivo obligatorio
      if (!this.reason?.trim()) {
        this.$emit('error', 'Debe ingresar un motivo.');
        return;
      }

      this.loading = true;
      try {
        if (this.isAlreadyBlacklisted) {
          // CASO 3: Ya estaba en lista negra → actualizar motivo
          await Api360Service.updateBlacklist(this.userRut, this.reason.trim(), true, this.token);
        } else {
          // CASO 4: No estaba en lista negra → crear nuevo registro
          await Api360Service.createBlacklist(this.userRut, this.reason.trim(), this.token);
        }
        this.$emit('saved');
        this.closeModal();
      } catch (error) {
        this.$emit('error', 'No se pudo guardar el registro en Lista Negra.');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>